import { PlansLandingPage } from '../modules/landing-page/PlansLandingPage';

export default function IndexPage() {
  return <PlansLandingPage />;
}
